import React, { useState, useEffect, useRef, divRef, lazy, Suspense } from "react";
import { alert_error, alert_success } from "../../../../AppContext";
import { Cookies } from "../../../../index.js";
import Iframe from 'react-iframe';
import { useLocation } from 'react-router-dom';
import axios from "axios";
import AdSense from 'react-adsense';
import { ClipLoader, PulseLoader } from 'react-spinners';
const LazyReCAPTCHA = lazy(() => import("../../../../app_structure/LazyReCAPTCHA"));

const Jopsearch = ({ datajoptiktok }) => {
    const iframeId = 'iframeContainer'; // Đặt id cho phần tử div
    const [iframeHeight, setIframeHeight] = useState(null); //None Kích thước mặc định
    const location = useLocation();
    const recaptchaRef = React.createRef();
    const [currentStep, setCurrentStep] = useState(1);
    const [nutorder, setnutorder] = useState("Xác nhận");
    const [nutxuly, setnutxuly] = useState(0);
    const [isDisabled, setIsDisabled] = useState(false);
    const [iframeKey, setIframeKey] = useState(0);
    const [chuadangnhap, setchuadangnhap] = useState(true);
    const [gtoken, setgtoken] = useState('');
    const [chedo, setchedo] = useState(false);
    const [loadcheoweb, setloadcheoweb] = useState(false);
    const [data_ok, setdata_ok] = useState(null);
    const [linkweb, setLinkweb] = useState(""); // Khai báo biến linkweb ở đây và khởi tạo giá trị ban đầu là chuỗi rỗng
    const [code_input, setCode] = useState(""); // Khai báo biến code_input để lưu trữ mã
    const [api_key, setapi_key] = useState('');
    const [buttonTextjop, setbuttonTextjop] = useState("Xác Thực Captcha để nhận Coins nhé");
    const [count, setCount] = useState(10);
    const [show_example, setshow_example] = useState(false);

    useEffect(() => {
        if (count > 0) {
            const countdownInterval = setInterval(() => {
                setCount(count - 1);
            }, 1000);

            return () => clearInterval(countdownInterval);
        }
    }, [count]);
    useEffect(() => {
        // Tìm phần tử div với id
        const divElement = document.getElementById(iframeId);

        // Nếu phần tử không tồn tại, hãy tạo nó
        if (!divElement) {
            const newDiv = document.createElement('div');
            newDiv.id = iframeId;
            document.body.appendChild(newDiv);
        }

        // Cập nhật kích thước iframe
        const divTop = document.getElementById(iframeId).getBoundingClientRect().top;
        const windowHeight = window.innerHeight * 0.83;
        const newHeight = `${windowHeight - divTop}px`;
        setIframeHeight(newHeight);
    }, []);
    useEffect(() => {
        setTimeout(() => {
            const myCookieValue = Cookies.get('apikey');
            console.log(myCookieValue);
            setapi_key(myCookieValue);
        }, 100);
    }, []);
    useEffect(() => {
        const myCookieValue = Cookies.get('apikey');
        if (myCookieValue) {
            if (api_key != '') {
                setchuadangnhap(false);
            }
        }
        setTimeout(() => {
            if (myCookieValue) {
                if (api_key != '') {
                    setchuadangnhap(false);
                    laydulieujop();
                }
            }
            else {
                setIsDisabled(true);
                setchuadangnhap(true);
            }
        }, 400);

    }, [api_key]);
    const handleContinue = () => {
        if (currentStep < 3) {
            setCurrentStep(currentStep + 1);
        } else {
            // Nếu ở bước cuối, quay lại bước đầu
            setCurrentStep(1);
        }
    };
    const laydulieujop = async () => {
        setIsDisabled(false);
        setdata_ok(null);
        if (location.pathname.includes('/proweb')) {
            const jasdjnlaksdl = 'search';
            setchedo(jasdjnlaksdl);
        }
        else if (location.pathname.includes('/cheoweb')) {
            const jasdjnlaksdl = 'cheoweb';
            setchedo(jasdjnlaksdl);
        }
    };

    function chuyenhuong(data) {
        // Xử lý dữ liệu ở đây
        console.log(data);
        if (data.status == 0 || data.status == "0") {

        }
        else if (data.router == false) {
            setTimeout(function () {
                window.location.href = data.redirects;
            }, 1500);
        }
        else {

        }
    };
    const resetRecaptcha = () => {
        window.grecaptcha.reset();
        setgtoken(null);
    };
    function testFunction(response) {
        if (chedo == 'cheoweb') {
            setloadcheoweb(false);
            reloadIframe();
            resetRecaptcha();
            setbuttonTextjop('Xác Thực Captcha');
            setCount(15);
        }

        // const orderok = info.order;
        // const error = info.error;
        setnutorder("đặt tiếp luôn nào");
        setnutxuly(0);
        if (response.data.status != 1 && response.data.error) {
            alert_error(response.data.error);
            chuyenhuong(response.data);
            laydulieujop();
        }
        else if (response.data.status == 1 || response.data.order) {
            alert_success(response.data.order);
            laydulieujop();
        }
        else {
            alert_error('Đã xảy ra lỗi máy chủ vui lòng liên hệ admin');
        }
    };
    function saochep(value) {
        alert_success('Đã sao chép');
        window.saochepnative(value);

    };

    function handleSubmitcheoweb(value) {
        const apikey = Cookies.get("apikey");
        setloadcheoweb(true);
        setnutxuly(1);
        setnutorder("Please wait a moment 😊");
        axios
            .post("https://hust.media/jop/google/checkjop.php", {
                apikey: apikey,
                chedo: chedo,
                code_input: linkweb,
                gtoken: value,

            })
            .then((response) => testFunction(response))
            .catch((error) => alert_error(error));
    };
    const reloadIframe = () => {
        setIframeKey(prevKey => prevKey + 1);
    };

    const stepDescription = {
        1: (
            <div className=" bg-gray-100">
                {datajoptiktok && datajoptiktok.length != 0 && <> <div className="max-w-xl w-full p-2 space-y-2 bg-white rounded-md shadow-md text-center">
                    {/* Các nút và văn bản đẹp */}
                    <div className="text-black text-base">
                        Sao chép từ khóa{" "}
                        <span className=" text-xl font-bold	 text-blue-500  cursor-pointer">
                            {datajoptiktok.magiaodich}
                        </span>{" "}
                    </div>
                    <div className="text-black text-base">
                        dán lên <span className=" text-xl font-bold	 text-blue-500  cursor-pointer">
                            Google.com
                        </span>{" "} để tìm kiếm trang web
                    </div>
                </div></>}
            </div>
        ),
        2: (
            <div>
                {datajoptiktok && datajoptiktok.length != 0 && <>
                    Bấm vào website giống ảnh bên dưới{" "}
                    <div className="items-center justify-center bg-gray-100">
                        <div className="max-w-xl w-full p-6 space-y-6 bg-white rounded-md shadow-md">
                            {/* Logo và ô tìm kiếm */}
                            <div className="flex items-center space-x-4">
                                <img
                                    className="h-10"
                                    src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png"
                                    alt="Google Logo"
                                />
                                <div className="flex-grow px-4 py-2 border text-black border-gray-300 rounded-md focus:outline-none focus:border-blue-500">
                                    {datajoptiktok.magiaodich}
                                </div>
                            </div>

                            {/* Kết quả tìm kiếm */}
                            <div>
                                {/* Tiêu đề kết quả */}

                                <div className="text-lg text-black font-bold">Kết quả tìm kiếm</div>

                                {/* Một kết quả tìm kiếm */}
                                <div className="mt-3">
                                    <div className="white-space break-all text-sm text-gray-500">
                                        {datajoptiktok.jop_name}
                                    </div>
                                    <div className="text-2xl text-blue-500 hover:underline">
                                        {datajoptiktok.jop_description}
                                    </div>
                                    {/* <p className="text-gray-700 text-base">
                                        {datajoptiktok.description}
                                    </p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </>}
                ở kết quả trang 1 hoặc trang 2,3,4,5
            </div>
        ),
        // 2: "Khi trang tải xong kéo xuống cuối trang click vào nút 'Bấm đây để lấy mã' để tiếp tục.",
        3: (<div className=" bg-gray-100">
            {datajoptiktok && datajoptiktok.length != 0 && <>
                <div className="max-w-xl w-full p-2 space-y-2 bg-white rounded-md shadow-md text-center">
                    {/* Các nút và văn bản đẹp */}
                    <div className="text-black text-lg">
                        Khi trang tải <strong className="text-blue-500">chụp ảnh màn hình</strong> để gửi vô dưới.
                    </div>
                    <div className="text-black text-sm">
                        Bạn sẽ được duyệt sau khi làm đúng theo các bước hướng dẫn
                    </div>
                </div>       </>}</div>),
    };

    const stepColors = {
        1: "bg-red-400",
        2: "bg-purple-400",
        3: "bg-blue-400",
    };
    const handleRecaptchaChange = (value) => {
        console.log(value);
        const maxLength = 200;

        if (value.length > maxLength) {

            // setnutxuly(1);
            setbuttonTextjop('Bạn hãy đợi vài giây để app xử lý nhé');
            setgtoken(value);
            handleSubmitcheoweb(value);
        }
        else {
            setbuttonTextjop('Đã xảy ra lỗi tải lại trang nhé');
        }
    }
    return (
        <div>
            <div className="w-full h-full">
                <div className="flex flex-col justify-center items-center">
                    <div className="mt-1 p-2 rounded-lg w-full shadow-xl bg-gradient-to-r from-pink-400 to-purple-400">
                        <div className="px-2" >
                            {location.pathname.includes('/proweb') && !chuadangnhap &&
                                (<>
                                    <h1 className="text-2xl font-bold text-white mb-3">HƯỚNG DẪN xem LINK</h1>
                                    <p className="text-base text-white mb-3">
                                        Lưu ý: Vui lòng không sử dụng Proxy (VPN), 1.1.1.1 khi vượt link.
                                    </p></>)
                            }
                            <div id={iframeId} >    </div>
                            {!chuadangnhap && (<>     {

                                data_ok && !chuadangnhap ? (
                                    <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
                                        <ClipLoader color="#fff" size={150} />
                                    </div>
                                ) :

                                    (location.pathname.includes('/proweb') || location.pathname.includes('/cheoweb')) && (
                                        <>
                                            <h2>Hết nhiệm vụ, vui lòng xem xét làm jop khác hoặc mua sắm để hỗ trợ cộng đồng. 🛍️</h2>
                                        </>
                                    )}
                            </>)}
                            {chuadangnhap ? (<>
                                <div className="z-index-1 position-relative">
                                    <a className="link-light mb-4 font-sans-serif fs-4 d-inline-block fw-bolder" href="/">hust.media</a>
                                    <p className="opacity-75 text-black">Là một hệ thống trao đổi tương tác một cách tự nhiên và an toàn. Hệ thống hoạt động theo nguyên tắc tự nguyện trao đổi giữa các thành viên, cùng giúp nhau tăng tương tác, tăng hiệu quả bán hàng, truyền thông.<br />#traodoisub , #tangsub, #tuongtaccheo, #tuongtacfb, #tangtheodoimienphi, #tanglikemienphi, #tanglike, #tangtheodoi, #tangcmt, #tangcamxuc, #tangshare, #cayxu, #toolcayxu, #tangview, #tangtiktok, #traodoitiktok, #tiktok </p>
                                </div>
                            </>) : (
                                <>{datajoptiktok && !location.pathname.includes('/proweb')
                                    && (
                                        <>{datajoptiktok.id}
                                            {datajoptiktok.magiaodich && (<>    <div className="flex text-base flex-col gap-4">
                                                {Object.keys(stepDescription).map((step) => (
                                                    <div
                                                        key={step}
                                                        className={`rounded-lg p-4 ${stepColors[step]} ${currentStep === parseInt(step) ? "block" : "hidden"
                                                            }`}
                                                    >
                                                        <h2 className="text-xl font-bold text-white mb-2">Bước {step}</h2>
                                                        <p className="text-lg text-white mb-4">{stepDescription[step]}</p>
                                                        {currentStep === parseInt(step) ? (
                                                            <div className="flex gap-2">
                                                                {currentStep === 1 && (
                                                                    <button
                                                                        onClick={() => saochep(datajoptiktok.magiaodich)}
                                                                        type="button"
                                                                        className="bg-blue-500 text-white font-bold py-2 px-4 rounded"
                                                                    >
                                                                        Sao chép
                                                                    </button>
                                                                )}

                                                                <button
                                                                    type="button"
                                                                    className="bg-white text-purple-400 font-bold py-2 px-4 rounded"
                                                                    onClick={handleContinue}
                                                                >
                                                                    {currentStep < 3 ? "Tiếp tục" : "Quay lại Bước 1"}
                                                                </button>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                ))}
                                            </div>
                                                {/* Ô nhập mã */}
                                                {(currentStep == 1 || currentStep == 3) &&
                                                    (<div className="mt-3 p-1 bg-gradient-to-r from-pink-200 to-purple-200 rounded-md shadow-md">
                                                        <form >
                                                            <div className="text-xl font-bold text-white mb-2">Xong bạn chụp ảnh màn hình bước này:</div>
                                                        </form>
                                                    </div>
                                                    )}   </>)}
                                        </>
                                    )
                                }</>)}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Jopsearch;
